import type { FC } from 'react';

import wweLogo from '@wwe-portal/ui/assets/images/common/wwe-logo.webp';

import { CircularProgressIcon } from '../icons/circular-progress-icon';

export const ProgressingDialogHead: FC<{
  progressPercent: number;
  duration: number;
}> = ({ progressPercent, duration }) => {
  return (
    <div className="relative flex h-full w-full items-center justify-center">
      <div className="h-[64px] w-[64px] overflow-hidden rounded-full">
        <img alt="success" height="100%" src={wweLogo} width="100%" />
      </div>
      <div className="absolute inset-0">
        <CircularProgressIcon
          duration={duration}
          height="100%"
          progressPercent={progressPercent}
          width="100%"
        />
      </div>
    </div>
  );
};
